import { css } from '@emotion/core'

export const form = css`
  text-align: left;
`

export const buttonContainer = css`
  text-align: center;
`

export const confirmButton = css`
  width: 50%;
`
